import CustomField from "components/common/CustomField";
import CustomLabel from "components/common/CustomLabel";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import FileUpload from "components/common/FileUpload";
import FormButtons from "components/common/FormButtons";
import { rewardSchema } from "components/common/Validation";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getRewardsList,
  updateRewardsScreen,
} from "store/actions/couponAction";

const initialValues = {
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  imageUrl: [],
};

const RewardPage = ({ mode }) => {
  const { t } = useTranslation();
  document.title = t("Reward Page | Work Space");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { isLoading, loading, rewardsList } = useSelector(
    (state) => state.Coupons
  );

  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    const getDetails = () => {
      dispatch(getRewardsList());
    };
    getDetails();
  }, []);

  useEffect(() => {
    if (rewardsList) {
      // Destructure keys from meetingDetails
      const { name, nameAr, description, descriptionAr, imageUrl } =
        rewardsList?.rewardScreen || {};

      // Update formValues using destructured values
      setFormValues((prevValues) => ({
        ...prevValues,
        name,
        nameAr,
        description,
        descriptionAr,
        imageUrl: [imageUrl] || [],
      }));
    }
  }, [rewardsList]);

  const handleOnSubmit = (values, { setSubmitting }) => {
    const { name, nameAr, description, descriptionAr, imageUrl } = values;

    let data = new FormData();
    data.append("rewardScreen[name]", name);
    data.append("rewardScreen[nameAr]", nameAr);
    data.append("rewardScreen[description]", description);
    data.append("rewardScreen[descriptionAr]", descriptionAr);

    data.append("rewardScreen[imageUrl]", imageUrl[0]);

    data.append("id", rewardsList?._id);
    // console.log(data);
    dispatch(updateRewardsScreen(data))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          navigate(-1);
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_page add_workshop_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("Rewards Page")} />
              <Formik
                initialValues={formValues}
                validationSchema={rewardSchema}
                enableReinitialize={true}
                onSubmit={handleOnSubmit}
              >
                {({ values, setFieldValue, errors, touched }) => (
                  <Form>
                    <Row className="common_wrapper">
                      <Col lg={12}>
                        <FileUpload
                          uploadedFiles={values.imageUrl || []}
                          setUploadedFiles={(files) =>
                            setFieldValue("imageUrl", files)
                          }
                          maxFiles={1}
                          maxFileSize={0.3 * 1024 * 1024} // 5 MB
                          acceptedFileTypes={[
                            "image/png",
                            "image/jpeg",
                            "image/svg+xml",
                          ]}
                          requireSquare={false}
                          requireRectangle={false}
                          // onChange={handleFilesChange}
                          className={
                            touched?.imageUrl && errors?.imageUrl
                              ? "invalid"
                              : ""
                          }
                        />
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="name"
                            label={t("English Title")}
                          />
                          <CustomField
                            name="name"
                            type="text"
                            placeholder={t("Enter English Title")}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="nameAr"
                            label={t("Arabic Title")}
                          />
                          <CustomField
                            name="nameAr"
                            type="text"
                            placeholder={t("Enter Arabic Title")}
                            touched={touched}
                            errors={errors}
                            isArabic={true}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="description"
                            label={t("English Description")}
                          />
                          <CustomField
                            name="description"
                            placeholder="Enter English Description"
                            touched={touched}
                            errors={errors}
                            as="textarea"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="descriptionAr"
                            label={t("Arabic Description")}
                          />
                          <CustomField
                            name="descriptionAr"
                            placeholder="Enter Arabic Description"
                            touched={touched}
                            errors={errors}
                            as="textarea"
                            isArabic={true}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="px-0 my-4">
                      <FormButtons
                        isLoading={isLoading}
                        addBtnText={t("Update")}
                      />
                    </Row>
                  </Form>
                )}
              </Formik>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default RewardPage;
